import {
  MediaFileActionManager,
  ShowCreateActionManager,
  ShowUpdateActionManager,
} from "../../action_managers/shows";
import { connect } from "react-redux";
import get from "lodash/get";
import { distribute } from "../../action_managers/distributions";
import { change } from "redux-form";
import { withRouter } from "react-router";
import ShowFormModal from "./show_form_modal";
import UploadModalActionManager from "../../action_managers/upload_modal";
import { showMessageWithTimeout } from "../../actions/app";
import messageType from "../../constants/message_types";
import { distributionKeyNames } from "../../constants/distribution";

function mapStateToProps(state) {
  var props = {
    user: state.user.user,
    mediaFiles: state.mediaFiles,
    isLoading: state.showForm.isLoading || state.mediaFileUpload.isLoading,
    isSuccess: state.showForm.isSuccess,
    shows: state.shows.shows,
    validationErrors: state.showForm.validationErrors,
    errorMessage: state.showForm.errorMessage,
    imageUploader: state.imageUploader,
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMediaFile: (mediaFileUUID, authToken) => {
      dispatch(new MediaFileActionManager({ mediaFileUUID, authToken }).run());
    },
    setError: errorMessage => {
      dispatch(showMessageWithTimeout(errorMessage, messageType.Error));
    },
    createShow: (show, user) => {
      dispatch(new ShowCreateActionManager({ show, user }).run()).then(response => {
        if (response.status === 200) {
          var showUUID = get(response, "json.uuid");
          if (showUUID) {
            dispatch(
              distribute(showUUID, [
                distributionKeyNames.googlePodcasts,
                distributionKeyNames.radioPublic,
              ])
            );
          }
        }
      });
    },
    updateShow: (show, user) => {
      dispatch(new ShowUpdateActionManager({ show, user }).run());
    },
    fileUpload: (file, fileName, user) => {
      return dispatch(
        new UploadModalActionManager({
          file,
          fileName,
          authToken: user.authToken,
        }).run()
      );
    },
    setImageFileUUID: (mode, mediaFileUUID) => {
      return dispatch(change("show-" + mode, "imageMediaFileUUID", mediaFileUUID));
    },
    setImageFileData: (mode, file) => {
      return dispatch(change("show-" + mode, "imageFileData", file));
    },
  };
}

const ShowFormModalWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShowFormModal)
);

export default ShowFormModalWrapper;
